<template>
  <LoadingElement v-if="isLoading" class="aspect-square w-full bg-transparent md:aspect-video" />
  <template v-else>
    <ProductCrossSellingGroup
      v-for="crossSelling in crossSellings"
      :key="crossSelling.id"
      :cross-selling="crossSelling"
      @close-cross-selling-modal="$emit('close-cross-selling-modal')"
    />
  </template>
</template>

<script setup lang="ts">
import { useCrossSelling } from "~/composables/shop/useCrossSellings";
import LoadingElement from "~/templates/elements/LoadingElement.vue";
import ProductCrossSellingGroup from "~/templates/components/shop/product/ProductCrossSellingGroup.vue";
defineEmits(["close-cross-selling-modal"]);
const isLoading = ref(true);

const { crossSellings, loadCrossSellingProducts } = await useCrossSelling();

onMounted(async () => {
  await loadCrossSellingProducts();
  isLoading.value = false;
});
</script>
